<template>
  <div class="app-container">
    <!-- <div class="detailsTitle">
      <h4>转货通知</h4>
    </div> -->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
            <el-form-item label="转货通知单号" label-width="110px">
              <el-input size="mini" v-model.trim="searchFrom.tforecastBillcode" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="状态">
            <el-select v-model="searchFrom.status" size="mini" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="未处理" value="未处理"></el-option>
              <el-option label="已入库" value="已入库"></el-option>
              <el-option label="已取消" value="已取消"></el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="创建时间:" class="item2" >
                <el-date-picker
                    v-model="searchFrom.createTimes"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                ></el-date-picker>
              </el-form-item>
        </div>
        <div style="padding-left: 10px">
          <el-form-item>
            <el-button type="primary" @click="chaxun" size="mini" >查询</el-button>
            <el-button type="primary" @click="chongzhi" size="mini">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--表格-->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" ref="table" highlight-current-row :data="tableData" @row-click="dianjixuanzhong" bordersize="mini" @selection-change='selectGoods' style="width: 100%" center border class="tableComent">
        <!-- <el-table-column type="selection" width="55" fixed=""> </el-table-column> -->
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column label="操作"  width="120">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini"     @click="fujianFn(scope.row)">附件</el-button>
                <el-button type="text" size="mini"     @click="rencheFn(scope.row)">人车</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="tforecastBillcode" label="转货通知单号" align="center"  min-width="160"></el-table-column>
         <!-- <el-table-column :show-overflow-tooltip="true" prop="sbillBillcode" label="提单号" align="center" width="100"></el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="status" label="状态" align="center" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="companyName" label="原货主" align="center" min-width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="transferName" label="新货主" align="center" min-width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="tforecastDate" label="过户时间" align="center" width="170"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime"  label="创建时间" align="center" width="170"></el-table-column>
      </el-table>
      <!--分页-->
      <div class="pags" style="text-align: left">
        <el-pagination background @current-change="handleCurrentChangeA" :current-page="current" :page-size="pagesize" :page-sizes="[50,100,200,500]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeA" :total="total"></el-pagination>
      </div>
    </div>
    <!--详情表格-->
    <div class="market_out" style="margin-top:40px">
      <div class="detailsTitle" style="justify-content: start;">
        <h4>货物详情</h4>
        <div style="font-size:14px;margin-left:10px;padding-top:8px">
          <span>
            总吨数:
            <span style="color: red">{{ allWeight }}</span> &nbsp;吨
          </span>
          <span style="margin-left: 15px">
            总件数:
            <span style="color: red">{{ allNumber }}</span> &nbsp;件
          </span>
        </div>
      </div>
      <div class="ruKuZuoyeWarp-body-detailsTab">
        <div class="ruKuZuoyeWarp-body-table" :style="{ height: XQh }">
          <el-table height="100%" size="mini" ref="tabref" :data="xiangqingTableData" style="width: 100%" :header-cell-style="{
                        background: '#F5F5F5',
                        color: 'black',
                      }" class="tableComent">
            <el-table-column type="index" align="center" fixed label="序号" width="60"></el-table-column>
            <el-table-column prop="tforecastBillbatch" min-width="160" label="过户通知单明细批号"></el-table-column>
            <el-table-column prop="partsnameName" min-width="120" label="品名"></el-table-column>
            <el-table-column prop="productareaName" min-width="160" label="产地"></el-table-column>
            <el-table-column prop="goodsSpec" min-width="120" label="规格"></el-table-column>
            <el-table-column prop="goodsMaterial" min-width="120" label="材质"></el-table-column>
            <el-table-column prop="goodsCodenum2" min-width="120" label="单重（吨）"></el-table-column>
            <el-table-column prop="goodsNum" width="120" label="件数"></el-table-column>
            <el-table-column prop="goodsWeight" min-width="120" label="重量（吨）"></el-table-column>
          </el-table>
        </div>
        <!--分页-->
        <div class="pags" style="text-align: left">
          <!-- <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="currentXQ" :page-size="pagesizeXQ" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ" :total="totalXQ"></el-pagination> -->
        </div>
      </div>
      <!-- 附件 -->
      <el-dialog  title="附件" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="fujianFlag" width="500px" center>
        <div class="fujianBox">
          <el-button type="text" v-for="item in fujianList" @click="fujianClick(item)" :key="item.id">{{item.name}}</el-button>
        </div>
        <el-dialog  title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag"
          append-to-body width="800px" center>
          <div style="text-align: right;">
            <div id="printMe"  ref="print">
              <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
            </div>
          </div>
        </el-dialog>
      </el-dialog>
      <!-- 人车 -->
      <el-dialog  title="人车" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="rencheFlag" width="800px" center>
        <el-table height="400px" size="mini"  ref="tabref" :data="rencheList" style="width: 100%">
          <el-table-column type="index" align="center" fixed label="序号" width="60"></el-table-column>
          <el-table-column prop="vehicalNumber" min-width="160" label="车牌号"></el-table-column>
          <el-table-column prop="driverName" width="160" label="司机姓名"></el-table-column>
          <el-table-column prop="driverMobile" min-width="160" label="司机手机号"></el-table-column>
          <el-table-column prop="driverIdcard" width="200" label="司机身份证号"></el-table-column>
          </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { findChangeMainList, findChangeGoodsList, findFileList, findVehicalList } from '@/api/wms-access'
export default {
  components: {
  },
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      xiangqingTableData: [],
      searchFrom: { },
      h: '500px',
      XQh: '200px',
      tableData: [],
      pagesize: 50,
      current: 1,
      total: 0,
      pagesizeXQ: 20,
      currentXQ: 1,
      totalXQ: 0,
      allNumber: 0,
      allWeight: 0,
      fujianFlag: false,
      fujianList: [],
      lookImgFlag: false,
      imgUrl: '',
      rencheFlag: false,
      rencheList: [],
      btnFlg: [],
      btnIdArr: ['01F00V0100', '01F00V0200', '01F00V0300', '01F00V0400', '01F00V0500', '01F00V0600', '01F00V0700']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/carBill')
    console.log(this.btnFlg, 'this.btnFlg ')
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = 0.6 * pH - h - 50 + 'px'
    this.XQh = 0.4 * pH - 180 + 'px'
  },
  methods: {
    // 附件
    fujianFn (row) {
      findFileList({ mainId: row.id, businessType: '转货' }).then(res => {
        if (res.length == 0) {
          this.$alert('此订单没有附件', '系统提示')
        } else {
          this.fujianFlag = true
          this.fujianList = []
          res.forEach(item => {
            var filename = item.url.split('/').pop()
            this.fujianList.push({
              name: filename,
              url: item.url
            })
          })
        }
      })
    },
    fujianClick (row) {
      if (this.isImage(row.name)) {
        this.lookImgFlag = true
        this.imgUrl = row.url
        // this.downloadIamge(row.url, row.name)
      } else {
        // window.open(row.url)
      }
      this.downfileFn(row.url, row.name)
    },
    // 下载文件
    downfileFn (url, name) {
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        const a = document.createElement('a')
        a.href = URL.createObjectURL(blob)
        // 测试链接console.log(a.href)
        a.download = name // 下载文件的名字
        document.body.appendChild(a)
        a.click()
      })
    },
    downloadIamge (src, imgName) {
      let image = new Image()
      image.src = src
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        let c = document.createElement('canvas')
        c.width = image.width
        c.height = image.height
        c.getContext('2d').drawImage(image, 0, 0, image.width, image.height)
        let a = document.createElement('a')
        a.download = imgName
        a.href = c.toDataURL('image/png')
        a.click()
      }
    },
    isImage (filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension)
    },
    // 人车
    rencheFn (row) {
      findVehicalList({ mainId: row.id }).then(res => {
        this.rencheList = res
        this.rencheFlag = true
      })
    },
    // 主数据
    getList () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      findChangeMainList({
        pageNo: this.current, // 页数
        pageSize: this.pagesize, // 条数
        ...this.searchFrom
      })
        .then((res) => {
          this.total = res.total
          this.tableData = res.list
          if (this.tableData[0]) {
            setTimeout(() => {
              this.$refs.table.toggleRowSelection(this.$refs.table.data[0])
              this.$refs.table.setCurrentRow(this.$refs.table.data[0])
              findChangeGoodsList({
                mainId: this.$refs.table.data[0].id,
                pageNo: this.currentXQ,
                pageSize: this.pagesizeXQ
              })
                .then((res) => {
                  this.xiangqingTableData = res.list
                  this.allWeight = res.weight
                  this.allNumber = res.number
                  // this.totalXQ = res.total
                })
                .catch((err) => {
                  DonMessage.error(err.message)
                })
            }, 10)
          } else {
            this.xiangqingTableData = []
            this.totalXQ = 0
            this.allWeight = 0
            this.allNumber = 0
          }

          loading.close()
        })
        .catch((err) => {
          DonMessage.error(err.message)
          loading.close()
        })
    },
    dianjixuanzhong (row, column, event) {
      this.xuanzhongArr = row
      this.$refs.table.toggleRowSelection(row)
      findChangeGoodsList({
        mainId: row.id,
        pageNo: this.currentXQ,
        pageSize: this.pagesizeXQ
      })
        .then((res) => {
          this.xiangqingTableData = res.list
          this.totalXQ = res.total
          this.allWeight = res.weight
          this.allNumber = res.number
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 选择数据
    selectGoods (selection) {

    },
    peihuoRow (row, column, event) {
      this.$refs.peihuoTable.toggleRowSelection(row)
    },
    selectPeihuo (selection) {
      this.selectListPH = selection
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongzhi () {
      this.searchFrom = {}
      this.pagesize = 50
      this.current = 1
      this.currentXQ = 50
      this.pagesizeXQ = 1
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.pagesize = val
      this.getList()
    },
    // 表格分页
    handleCurrentChangeXQ (val) {
      this.currentXQ = val
      this.getList()
    },
    handleSizeChangeXQ (val) {
      this.pagesizeXQ = val
      this.getList()
    }
  }
}
</script>

  <style lang="less" scoped>
/deep/ .searchBox .el-form--inline .el-form-item {
  margin-bottom: 10px;
}
/deep/.searchBox {
  .el-input {
    width: 150px;
    display: inline-block;
  }
  .el-input__inner {
    width: 100%;
  }
  .el-date-editor{
    width: 421px;
  }
}
/deep/.jiaoyan {
  .el-input {
    width: 180px;
    display: inline-block;
  }
  .el-input__inner {
    width: 100%;
  }
}
.gjh{
    height: 45px;
    .el-textarea__inner{
      height: 100%;
    }
  }
.topLeft {
  display: flex;
  .item {
    margin-right: 16px;
  }
  .fa {
    font-size: 18px;
  }
}
/deep/.el-form{
  width: 100%;
}

.box{
  width: 100%;
   display: grid;
   grid-template-columns: repeat(auto-fill, 270px);
   grid-auto-flow: row dense;
   /deep/.el-textarea__inner{
    width: 150px;
    height: 68px;
   }
   .item1{
      grid-row-start: span 2;
    }
   .item2{
      grid-column-start: span 2;
      width: 540px;
   }
}
</style>
